import FastMarquee from "react-fast-marquee";

export default function Marquee({ items }) {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/10 py-8 md:py-10 overflow-hidden"
    >
      <FastMarquee speed={40} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <div key={i} className="flex items-center gap-16 pr-16">
            <span className="font-heading uppercase text-4xl md:text-6xl lg:text-7xl tracking-normal text-white/90">
              {item}
            </span>
            <span className="text-accent text-2xl md:text-4xl">★</span>
          </div>
        ))}
      </FastMarquee>
    </div>
  );
}
